export default {
  setAppointmentsData(state, data) {
    state.appointments = data;
  },
  setProvidersData(state, data) {
    state.providers = data;
  },
  setPatientsTags(state, data) {
    state.patientTags = data;
  },
  setSelectedProvider(state, providerId) {
    state.selectedProvider = providerId;
  },
  setIsProviderExists(state, status) {
    state.isProvidersExists = status;
  },
  setSelectedPatientTag(state, patientTag) {
    state.selectedPatientTag = patientTag;
  },
  setpatientsTableDataForSafe(state, data) {
    state.patientsTableDataForSafe = data;
  },
  setpatientsTableDataForProvider(state, data) {
    state.patientsTableDataForProvider = data;
  },
  setOriginalTableData(state, data) {
    state.originalTableData = data;
  },
};
